import { render, staticRenderFns } from "./GeneratePromoCodes.vue?vue&type=template&id=5ed84ecc&scoped=true"
import script from "./GeneratePromoCodes.vue?vue&type=script&lang=js"
export * from "./GeneratePromoCodes.vue?vue&type=script&lang=js"
import style0 from "./GeneratePromoCodes.vue?vue&type=style&index=0&id=5ed84ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed84ecc",
  null
  
)

export default component.exports